import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import cx from 'classnames';

import ArticlesTagsOverlay from '../ArticlesTagsOverlay';
import Icon from 'utils/components/icon';
import DropdownLink from '../../../../../common/dropdown-link';
import styles from './ArticlesTagsFilter.module.scss';
import { selectArticlesAppliedFiltersCount } from "../../../reducers/articlesSelectors";

interface IArticlesTagsFilterProps {
  className?: string;
  isTabsV2Enabled?: boolean;
}

const ArticlesTagsFilter = ({
  className,
  isTabsV2Enabled
}: IArticlesTagsFilterProps): ReactElement => {
  const appliedFiltersCount = useSelector(selectArticlesAppliedFiltersCount);
  const isAppliedFilters = appliedFiltersCount > 0;
  const appliedFiltersCountText = `(${appliedFiltersCount})`;

  return (
    <div className={cx(styles.container, className)}>
      <DropdownLink
        className={cx(styles.menuLabel, {
          [styles.menuLabelHighlighted]: isAppliedFilters
        })}
        tooltipClassName={styles.overlay}
        text={`Filter ${isAppliedFilters ? appliedFiltersCountText : ''}`}
        customContent={<ArticlesTagsOverlay isTabsV2Enabled={isTabsV2Enabled} />}
      >
        <Icon name="filter" className={styles.icon} />
      </DropdownLink>
    </div>
  );
};

export default ArticlesTagsFilter;
